import SelectorEngine from '../../utils/dom/selector-engine';
import BaseComponent from '../BaseComponent';
import EventHandler from '../../utils/dom/event-handler';

const NAME = 'FilterPanelHorizontal';

class FilterPanelHorizontal extends BaseComponent {
	constructor(element) {
		super(element);
		this._element = element;
		this.accordionWrapper = SelectorEngine.findOne('.lta-accordion--horizontal', this._element);
		this.form = this._element.closest('form');
		this.submitBtns = SelectorEngine.find('.lta-filter-panel__btn', this._element);
		this.accordionBtns = SelectorEngine.find('.lta-accordion--trigger', this._element);
		this.init();
	}

	static get NAME() {
		return NAME;
	}

	init() {

		this.accordionBtns.forEach((accordionTrigger) => {
			EventHandler.on(accordionTrigger, 'click', (e) => {
				const accordion = e.target.closest('.lta-accordion--item');
				const siblings = this.getSiblings(accordion);

				// Reset previous open panels
				siblings.forEach( (sibling) => {
					const panel = SelectorEngine.findOne('.lta-accordion--panel', sibling);
					const trigger = SelectorEngine.findOne('.lta-accordion--trigger', sibling);

					trigger.setAttribute('aria-expanded', false);
					panel.setAttribute('hidden', true);
				});
			});
		});

		this.submitBtns.forEach( (btn) => {
			EventHandler.on(btn, 'click', () => this.form.submit());
		});
	}

	getSiblings(e) {
		let siblings = [];

		if(!e.parentElement) {
			return siblings;
		}

		let sibling  = e.parentElement.firstChild;
		while (sibling) {
			if (sibling.nodeType === 1 && sibling !== e) {
				siblings.push(sibling);
			}
			sibling = sibling.nextElementSibling;
		}
		return siblings;
	}
}

export default FilterPanelHorizontal;
